module.exports = __webpack_public_path__ + "img/red-wallet.b5012c0d.svg";